import React from 'react'
import { FormattedMessage } from 'react-intl'
import { injector } from '../../ng-injector'
import { css, cx } from '@emotion/css'
import { paragraphTextCss } from '../text'
import { Link } from '@contrast-security-inc/design-system-typography'

const containerCss = css`
  margin-left: 20px;
`
const linkContainerCss = css`
  margin-left: 3px;
`

interface Props {
  readonly librariesGrid?: boolean
}
export function GridToggle({ librariesGrid }: Props) {
  return (
    <div className={cx(containerCss, paragraphTextCss)}>
      <FormattedMessage id="detail_needToReturnToOldUi" />
      <ToggleLink librariesGrid={librariesGrid} />
    </div>
  )
}

export function ToggleLink({ librariesGrid }) {
  return (
    <span className={linkContainerCss}>
      <FormattedMessage id="detail_weveGotYourBack">
        {(deleteCookie) => (
          <Link
            onClick={() => {
              removeCookie(librariesGrid)
            }}
          >
            {deleteCookie}
          </Link>
        )}
      </FormattedMessage>
    </span>
  )

  function removeCookie(librariesGrid) {
    injector.invoke([
      'GridToggleService',

      (GridToggleService) => {
        !librariesGrid
          ? GridToggleService.toggleOldGridOn()
          : GridToggleService.toggleOldLibrariesGridOn()
      }
    ])
  }
}
